<template>
  <div class="cr-page">
    <CloudReleaseSection />
  </div>
</template>

<script>
import CloudReleaseSection from "../components/CloudReleaseSection.vue";
export default { name: "CloudRelease", components: { CloudReleaseSection } };
</script>

<style scoped>
  .cr-page { min-height: 100vh; background: linear-gradient(180deg, #FEF6EE 0%, #FBF7F1 100%); color: var(--color-text); }
</style>
